import React from 'react';
import './StickyFooter.css';

interface StickyFooterProps {
  onSave: () => void;
  saving?: boolean;
  disabled?: boolean;
  message?: {
    type: 'success' | 'error' | 'warning' | 'info';
    text: string;
  } | null;
  onMessageClose?: () => void;
  onVisit?: () => void;
  visitDisabled?: boolean;
  visitTitle?: string;
}

const StickyFooter: React.FC<StickyFooterProps> = ({
  onSave,
  saving = false,
  disabled = false,
  message,
  onMessageClose,
  onVisit,
  visitDisabled = false,
  visitTitle
}) => {
  return (
    <div className="sticky-footer">
      <div className="sticky-footer-content">
        <div className="sticky-footer-left">
          {message && (
            <div className={`sticky-footer-message sticky-footer-message-${message.type}`}>
              <span className="sticky-footer-message-text">{message.text}</span>
              {onMessageClose && (
                <button
                  type="button"
                  className="sticky-footer-message-close"
                  onClick={onMessageClose}
                  aria-label="Close message"
                >
                  ×
                </button>
              )}
            </div>
          )}
        </div>
        <div className="sticky-footer-buttons">
          {onVisit && (
            <button
              type="button"
              className="admin-btn"
              onClick={onVisit}
              disabled={visitDisabled || saving}
              title={visitTitle}
            >
              Visit
            </button>
          )}
          <button
            type="button"
            className="admin-btn primary"
            onClick={onSave}
            disabled={saving || disabled}
          >
            {saving ? 'Saving...' : 'Save'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default StickyFooter;
